import { useEffect } from 'react';

const ALLOW_SELECTOR =
  'input, textarea, select, [contenteditable="true"], .allow-copy, .allow-copy *';

const nodeToElement = (node) => {
  if (!node) return null;
  if (node instanceof Element) return node;
  if (node.nodeType === Node.TEXT_NODE) return node.parentElement;
  return null;
};

const isSelectionInsideAllowed = () => {
  const selection = window.getSelection?.();
  if (!selection || selection.rangeCount === 0 || selection.isCollapsed) {
    return false;
  }

  const anchor = nodeToElement(selection.anchorNode);
  const focus = nodeToElement(selection.focusNode);

  return (
    Boolean(anchor?.closest(ALLOW_SELECTOR)) ||
    Boolean(focus?.closest(ALLOW_SELECTOR))
  );
};

const isAllowedTarget = (target) => {
  if (target instanceof Element && target.closest(ALLOW_SELECTOR)) {
    return true;
  }
  return isSelectionInsideAllowed();
};

const useContentProtection = (
  enabled =
    process.env.NODE_ENV === 'production' ||
    process.env.REACT_APP_CONTENT_PROTECTION === 'true',
) => {
  useEffect(() => {
    if (!enabled) return undefined;

    const blockIfProtected = (event) => {
      if (isAllowedTarget(event.target)) return;
      event.preventDefault();
    };

    const blockContextMenu = (event) => {
      if (isAllowedTarget(event.target)) return;
      event.preventDefault();
    };

    const blockShortcuts = (event) => {
      if (isAllowedTarget(event.target)) return;

      const key = event.key?.toLowerCase();
      const withModifier = event.ctrlKey || event.metaKey;

      if (withModifier && ['c', 'x', 'v', 'a', 's', 'u', 'p'].includes(key)) {
        event.preventDefault();
        return;
      }

      if (withModifier && event.shiftKey && ['i', 'j', 'c'].includes(key)) {
        event.preventDefault();
      }
    };

    document.addEventListener('copy', blockIfProtected);
    document.addEventListener('cut', blockIfProtected);
    document.addEventListener('paste', blockIfProtected);
    document.addEventListener('dragstart', blockIfProtected);
    document.addEventListener('contextmenu', blockContextMenu);
    document.addEventListener('keydown', blockShortcuts);
    document.documentElement.classList.add('content-protected');

    return () => {
      document.removeEventListener('copy', blockIfProtected);
      document.removeEventListener('cut', blockIfProtected);
      document.removeEventListener('paste', blockIfProtected);
      document.removeEventListener('dragstart', blockIfProtected);
      document.removeEventListener('contextmenu', blockContextMenu);
      document.removeEventListener('keydown', blockShortcuts);
      document.documentElement.classList.remove('content-protected');
    };
  }, [enabled]);
};

export default useContentProtection;
